module.exports = __webpack_public_path__ + "img/153c0d1.png";